import {
  Caption,
  IHtmlHighlight,
  PopoverConfiguration,
} from "~/typings/annotate/annotation";
import { HTMLAnnotator } from "../html-annotator";
import React, { useEffect, useState } from "react";

interface VideoAnnotatorProps {
  captions: Caption[];
  annotations: {
    highlights: IHtmlHighlight[];
    comments: any; //temporary until article comments are implemented
  };
  popoverConfiguration: PopoverConfiguration;
  trackMetric: (name: string, options?: { [key: string]: any }) => void;
  articleID: string;
  htmlContent?: string;
  investigatorInfo?: {
    ref: React.RefObject<HTMLDivElement>;
    visible: boolean;
  };
  endElement: React.ReactElement;
}

/* eslint-disable lingui/no-unlocalized-strings -- internal HTML markup, captions are user-provided */
export function VideoAnnotator({
  htmlContent,
  captions = [],
  ...props
}: VideoAnnotatorProps) {
  const { endElement } = props;
  const [editorContent, setEditorContent] = useState(() => {
    if (htmlContent) {
      return htmlContent;
    }
    return `<article>${captions
      .map((elt, index) => {
        return `<div class="flex"><span data-timestamp="${elt.start}" ></span><span data-start="${elt.start}" data-duration="${elt.duration}" data-index="${index}">${elt.text} </span></div>`;
      })
      .join("")}</article>`;
  });

  useEffect(() => {
    if (htmlContent) {
      setEditorContent(htmlContent);
      return;
    }
    setEditorContent(
      `<article>${captions
        .map((elt, index) => {
          return `<div class="flex"><span data-timestamp="${elt.start}" ></span><span data-start="${elt.start}" data-duration="${elt.duration}" data-index="${index}">${elt.text} </span></div>`;
        })
        .join("")}</article>`,
    );
  }, [captions, htmlContent]);
/* eslint-enable lingui/no-unlocalized-strings */

  return (
    <>
      <HTMLAnnotator editorContent={editorContent} {...props} />
      <>{endElement ? endElement : <></>}</>
    </>
  );
}
